/**
 * Item claim warning codes
 */
const ItemClaimWarningCodes = {
	OutOfStock: 1
};


/**
 * Get the user-facing message for a warning code's value.
 *
 * @param {Integer} code
 * @return {String}
 */
export const getMessage = code => {
	switch (code) {
		case ItemClaimWarningCodes.OutOfStock:
			return "Selling this item may not leave enough stock available to fulfil all commitments. Check stock levels at your current location.";
		default:
			return `Internal item claim error (E${code}).`;
	}
};


/**
 * Item claim warning code class.
 *
 * @package HOPS
 * @subpackage Orders
 * @copyright Heritage Operations Processing Limited
 */
export class ItemClaimWarningCode {

	/**
	 * Constructor.
	 *
	 * @param {Integer} code Warning code value
	 * @return {self}
	 */
	constructor(code) {

		/**
		 * Warning code value
		 *
		 * @type {Integer}
		 */
		this.code = code;

	}


	/**
	 * Get the warning message.
	 *
	 * @return {String}
	 */
	getMessage() {
		return getMessage(this.code);
	}

}

export default ItemClaimWarningCodes;
